import { getIn } from 'formik'
import { Input } from '../../Input'

export const InputForm = ({ field, form, sizeInput, label, ...props }) => {
  const error = getIn(form.errors, field.name)
  const touched = getIn(form.touched, field.name)

  return (
    <Input
      name={field.name}
      label={label}
      isInvalid={!!error && !!touched}
      errorText={error}
      {...field}
      {...props}
    />
  )
}